var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgObjectsIconMographical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 172,
    viewBox: "0 0 196 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.294 130.942L40.1548 50.3837L42.6293 42.1853L99.4114 9.56057L163.55 121.188L158.294 130.942Z",
    fill: "url(#paint0_linear_7_187)",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3822 50.9564L94.0098 19.487L158.295 131.08L103.668 162.549L39.3822 50.9564Z",
    fill: "#343434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3822 50.9564L94.0098 19.487L158.295 131.08L103.668 162.549L39.3822 50.9564Z",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3822 50.9564L94.0098 19.487L158.295 131.08L103.668 162.549L39.3822 50.9564Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5119 9.85188C99.6306 9.60254 99.5246 9.30421 99.2753 9.18554C99.0259 9.06688 98.7276 9.17282 98.6089 9.42216L99.5119 9.85188ZM94.9014 19.5398L99.5119 9.85188L98.6089 9.42216L93.9984 19.11L94.9014 19.5398Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.785 109.537L111.378 34.0131L118.228 30.4962L176.078 47.2482L159.754 106.68L150.785 109.537Z",
    fill: "url(#paint1_linear_7_187)",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.163 34.5324L166.841 50.5869L149.662 110.164L93.9843 94.1095L111.163 34.5324Z",
    fill: "#C957FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.163 34.5324L166.841 50.5869L149.662 110.164L93.9843 94.1095L111.163 34.5324Z",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.163 34.5324L166.841 50.5869L149.662 110.164L93.9843 94.1095L111.163 34.5324Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M176.49 47.8114C176.752 47.7237 176.893 47.4403 176.805 47.1785C176.718 46.9166 176.434 46.7755 176.172 46.8632L176.49 47.8114ZM167.126 50.9481L176.49 47.8114L176.172 46.8632L166.809 49.9999L167.126 50.9481Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4809 149.134L11.8431 109.415L16.9913 103.307L69.6944 80.6618L73.8597 140.801L66.4809 149.134Z",
    fill: "#D9D9D9",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6831 109.657L61.9967 88.5075L66.0536 148.951L38.5925 128.64L38.5906 128.638L12.6831 109.657Z",
    fill: "#212121"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6831 109.657L61.9967 88.5075L66.0536 148.951L38.5925 128.64L38.5906 128.638L12.6831 109.657Z",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6831 109.657L61.9967 88.5075L66.0536 148.951L38.5925 128.64L38.5906 128.638L12.6831 109.657Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8098 81.5959C70.0028 81.3985 69.9993 81.0819 69.8018 80.8888C69.6044 80.6958 69.2878 80.6993 69.0948 80.8968L69.8098 81.5959ZM62.4605 89.1119L69.8098 81.5959L69.0948 80.8968L61.7456 88.4127L62.4605 89.1119Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_187",
    x1: 80.6652,
    y1: -24.4704,
    x2: 102.345,
    y2: 57.2569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_187",
    x1: 183,
    y1: 28.6948,
    x2: 165.103,
    y2: 68.2608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectsIconMographical);
export default __webpack_public_path__ + "static/media/Objects Icon Mographical.ce10378875b194c3c78548254ca88a75.svg";
export { ForwardRef as ReactComponent };